import React from 'react';
import './App.css';

import AuthProvider from './components/utils/auth/AuthProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import MainSection from './components/layout/MainSection'
import ScrollToTop from '../src/components/utils/ScrollToTop'
import MaintenanceGuard from './components/utils/route/MaintenanceGuard';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/_common.sass';

const is_maintenance:Boolean = process.env.REACT_APP_IS_MAINTENANCE === 'true';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        {is_maintenance ? (
          <MaintenanceGuard>
            <Header/>
            <MainSection/>
            <Footer/>
          </MaintenanceGuard>
        ) : (
          <>
            <Header/>
            <MainSection/>
            <Footer/>
          </>
        )}
      </AuthProvider>
    </Router>
  );
}

export default App;
